<template>
  <div :class="['navigation-element',{active:active}]">
    <cms-icon :iconName="title" width="29" height="29">
      <slot></slot>
    </cms-icon>
    <span>{{title}}</span>
  </div>
</template>

<script>
export default {
  props: ["title", "active"]
};
</script>

<style scoped lang="scss">
.navigation-element {
  color: $warm-grey-color;
  padding: 6px 8px 2px 8px;
  &.active{
      color: $dark-sky-blue-color;
  }
}

span {
  display: block;
  font-size: 0.7rem;
}
</style>